<button
  class="dev-button btn-violet-solid"
  *ngIf="isLocalhost"
  (click)="redirectToProduction()"
>
  <svg-icon src="assets/img/icons/globus-white.svg"></svg-icon>
</button>
<router-outlet></router-outlet>
